<template>

    <div>

        <b-card>

            <b-row class="mb-2">

                <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">

                    <date-picker
                        v-model="start_date"
                        placeholder="Start Date"
                        class="f-1">
                    </date-picker> &nbsp;to&nbsp;
                    <date-picker
                        v-model="end_date"
                        placeholder="End Date"
                        class="f-1">
                    </date-picker>
                </b-col>

                <b-col sm="6" md="4" class="my-1">

                    <b-form-select v-model=" flag ">

                        <option value="">-- No Flag Specified --</option>
                        <option value="upd_id_is_already_taken_most_likely_from_matching_a_similar_provider">Upd taken</option>
                        <option value="fuzzy_match_result_mismatched_upd_id">Mismatch upd</option>
                        <option value="matching_problem">Matching problem</option>
                        <option value="fuzzy_matched_multiple">Matched multiple</option>
                        <option value="creation_in_upd_failed_check_provider_information">Cant create</option>
                        <option value="unknown_problem_creating_provider_in_upd">Unknown issue</option>
                    </b-form-select>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <carrier-dropdown v-model=" ltc_carrier_id "></carrier-dropdown>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <user-role-search-dropdown type="provider" v-model=" caregiver_id "></user-role-search-dropdown>
                </b-col>
            </b-row>
            <b-row class="mb-3">

                <b-col sm="12" class="d-flex align-items-center justify-content-between">

                    <p class="m-0 mt-1">Total: {{ totalRows }}</p>
                    <div class="d-flex align-items-center">

                        <b-button variant="info" @click=" loadTable() ">Generate</b-button>
                    </div>
                </b-col>
            </b-row>

            <div class="table-responsive">

                <b-table bordered striped hover show-empty
                    :items=" items "
                    :fields=" fields "
                    :current-page=" currentPage "
                    :per-page=" 0 "
                    :sort-by.sync=" sortBy "
                    :sort-desc.sync=" sortDesc "
                    :busy=" loading "
                >

                    <template v-slot:cell(caregiver_name)="row">

                        <b-link :href=" `/business/caregivers/${row.item.caregiver_id}#upd` " target="_blank">{{ row.item.caregiver_name }}</b-link>
                    </template>
                    <template v-slot:cell(actions)="row">

                        <div class="d-flex align-items-center justify-content-end">

                            <b-btn v-b-tooltip.hover title="Mark this record to remove it from the table" size="sm" variant="danger" @click=" deleteTrueUp( row.item ) " :disabled=" isLoading "><i class="fa fa-check-circle-o mr-2"></i>Acknowledge Record</b-btn>
                        </div>
                    </template>
                </b-table>
            </div>

            <b-row>

                <b-col lg="6" >

                    <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                </b-col>
                <b-col lg="6" class="text-right">

                    {{ paginationText }}
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>

    import PaginatedTable from "../../mixins/PaginatedTable";
    import FormatsDates from "../../mixins/FormatsDates";

    export default {

        mixins: [ PaginatedTable, FormatsDates ],
        data(){

            return {

                isLoading      : false,
                baseUrl        : '/business/true_up',

                caregiver_id   : '',
                start_date     : '',
                end_date       : '',
                ltc_carrier_id : '',
                flag           : '',

                fields : [

                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true,
                    },
                    {
                        key: 'caregiver_name',
                        label: 'Provider',
                        sortable: true,
                    },
                    {
                        key: 'flag',
                        label: 'Flag',
                        sortable: true,
                    },
                    {
                        key: 'created_at',
                        label: 'Created',
                        sortable: true,
                        formatter: ( value ) => { return this.formatDate( value ); }
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print',
                        sortable: false
                    },
                ]
            }
        },
        computed: {

            appliedFilters() { return '?start_date=' + this.start_date + '&end_date=' + this.end_date + '&caregiver_id=' + this.caregiver_id + '&flag=' + this.flag + '&ltc_carrier_id=' + this.ltc_carrier_id; },
        },
        methods: {

            deleteTrueUp( trueup ){

                let form = new Form({});
                this.isLoading = true;
                form.submit( 'delete', `/business/true_up/${trueup.id}` )
                    .then( res => this.loadTable() )
                    .finally( () => this.isLoading = false );
            }
        }
    }
</script>

<style>

</style>